import { post } from './Request'
import cookie from 'react-cookies'
import { isEmpty, isNotEmpty } from "../util/Strings";

export const getManagerList = async (query) => {
    const data = await post({
        url: '/api/manager/list',
        data: query
    })
    return data
}

export const addManager = async (managerInfo) => {
    const data = await post({
        url: '/api/manager/add',
        data: managerInfo
    })
    return data
}

export const deleteManagerById = async (id) => {
    const data = await post({
        url: '/api/manager/delete',
        data: {
            id: id
        }
    })
    return data
}

export const updateManager = async ({ id, status, authPath }) => {
    const data = await post({
        url: '/api/manager/update',
        data: {
            id: id,
            status: status,
            authPath: authPath
        }
    })
    return data
}

export const changePassword = async ({ sourcePassword, newPassword }) => {
    const data = await post({
        url: '/api/manager/changepassword',
        data: {
            sourcePassword: sourcePassword,
            newPassword: newPassword
        }
    })
    return data
}

export const getCurrentManager = async () => {
    const data = await post({
        url: '/api/manager/current'
    })
    return data
}

export const login = async ({ userName, password }) => {
    const data = await post({
        url: '/api/login',
        data: {
            userName: userName,
            password: password
        }
    })
    if (!data) {
        return false;
    }
    return await afterLogin(data)
}

export const isLogin = () => {
    const token = getToken()
    return isNotEmpty(token)
}

export const logout = () => {
    cookie.remove('token', { path: "/" })
}

export const getUserName = () => {
    const userName = cookie.load("userName")
    if (isNotEmpty(userName)) {
        return userName;
    } else {
        return ''
    }
}

export const getName = () => {
    const name = cookie.load("name")
    if (isNotEmpty(name)) {
        return name;
    } else {
        return ''
    }
}

export const getToken = () => {
    return cookie.load("token")
}

export const refresToken = async () => {
    const data = await post({
        url: '/api/refreshToken',
    })
    afterLogin(data)
}

export const getAuth = () => {
    const authPath = cookie.load("authPaht")
    return isEmpty(authPath) ? "" : authPath
}

const afterLogin = async (data) => {
    if (isNotEmpty(data.token)) {
        let expires = new Date(new Date().getTime() + 24 * 3600 * 1000);
        cookie.save("token", data.token, { expires: expires, path: "/" })
        cookie.save("userName", data.userName, { expires: expires, path: "/" })
        cookie.save("name", data.name, { expires: expires, path: "/" })
        const managerInfo = await getCurrentManager()
        cookie.save("authPaht", managerInfo.authPath, { expires: expires, path: "/" })
        return true;
    } else {
        this.logout();
        return false;
    }
}

export const statusMap = {
    1: {
        "color": "blue",
        "msg": "有效"
    },
    2: {
        "color": "red",
        "msg": "无效"
    }
}

